<!-- 网页顶部-->
<template>
        <div class="home_header">
        <img class="logo" :src="require('../../img/logo.png')" alt="" @click="go_page ('index')">
        <div :class="[$store.state.isPC?'top_menu':'mobile_menu']" v-show="$store.state.isPC?true:isclose" >
          <div :class="['menu_butn',$route.name=='index'?'menu_active':'']" @click="go_page ('index')">首页</div>
          <div :class="['menu_butn',($route.name=='productService' && $route.query.index==0)?'menu_active':'']" @click="go_page ('productService','1539415162975424512',0)">移动接入设备</div>
          <div :class="['menu_butn',($route.name=='productService' && $route.query.index==1)?'menu_active':'']" @click="go_page ('productService','1636584464106655744',1)">信息系统软件</div>
          <div :class="['menu_butn',($route.name=='productService' && $route.query.index==2)?'menu_active':'']" @click="go_page ('productService','1636584565269073920',2)">解决方案</div>
          <div :class="['menu_butn',$route.name=='aboutUs'?'menu_active':'']" @click="go_page ('aboutUs')">关于我们</div>
          <div :class="['menu_butn',$route.name=='contact'?'menu_active':'']" @click="go_page ('contact')">联系我们</div>
        </div>
        <div :class="['menu',isclose?'close':'']" @click="isclose=!isclose" v-if="!$store.state.isPC"></div>
      </div>

</template>

<script>
export default {
  data () {
    return {
      isclose:false
    };
  },

  components: {},

  computed: {},

  mounted () {

  },

  methods: {
    go_page (pageName, catalogId, index) {
      this.isclose=false
      this.$store.commit("setShowDetails",false)
      this.$router.push({ name: pageName || 'index', query: { catalogId, index } })
    }
  }
}

</script>
<style scoped>
.logo{
    height: 70%;
    cursor: pointer;
    margin-left: 10px;
    
}
.home_header{
    height: 69px;
    background-color:rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1000;
}
.top_menu {
  display: flex;
  color: #fff;
 margin-left: 150px;
}
.mobile_menu{
  display: flex;
    color: #fff;
    flex-direction: column;
    position: absolute;
    top: 69px;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    align-items: center;
    height: calc(100vh - 69px);
}
.mobile_menu  .menu_butn{
  margin-bottom: 20px;
  border-bottom: 1px solid #fff;
  /* padding-bottom: 20px;
  width: 40%; */
  text-align: center;
}
.top_menu .menu_butn {
  width: 100px;
   cursor: pointer;
  text-align: center;
  height: 69px;
  line-height: 63px;
  font-size: 14px;
}
 :hover .top_menu.menu_butn{
   transition: all 0.5s;
    border-top: 3px solid #fff;
    
 }
 .top_menu.menu_active{
 border-top: 3px solid #fff;
 }
 .login{
     color: #fff;
     border: 1px solid #fff;
     border-radius: 5px;
     width: 60px;
     height: 25px;
     line-height: 25px;
     text-align: center;
      margin-left:auto;
      margin-right: 50px;
         cursor: pointer;
         flex-shrink: 0;
       
 }
 :hover.login{
     transition:all 0.3s;
      box-shadow: 0px 0px 5px 0px rgba(255, 255, 255, 0.7)
 }

 .menu{
width: 40px;
height: 40px;
position: absolute;
right: 10px;
color: #fff;
}

.menu::after,.menu::before{
content: "";
display: block;
position: absolute;
left: 20%;
right: 20%;
top:50%;
height: 3px;
border-radius: 100px;
background: currentColor;
transform: translateY(-50%);
transition: all ease .3s;
}

.menu::after{
box-shadow: 0 -8px currentColor,0 8px currentColor;
}

.menu.close::after{
box-shadow:none;
}

.menu.close::after{
transform: translateY(-50%) rotate(45deg);
}

.menu.close::before{
transform: translateY(-50%) rotate(-45deg);
}
</style>
